import axios from 'axios';
import { SANCTUM_TOKEN } from 'constants/envVars';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(async request => {
	request.headers.Authorization = `Bearer ${SANCTUM_TOKEN}`;
	request.params = {
		...request.params,
		app: 'aa' //Pass app name to all requests
	};
	return request;
});

export default axiosInstance;
